import { CartStatus, ClaimRecord, ClaimRecordStatus } from '@typesApp/ClaimRecord'

export const isPollCartStatus = (status: ClaimRecordStatus | undefined): boolean => {
  return status === ClaimRecordStatus.INSURANCE_MEMBER_FOUND
}

export const isProductUpdateRequired = (cartStatus: CartStatus | undefined): boolean => {
  return cartStatus === CartStatus.PRODUCTS_UPDATE_REQUIRED
}

export const isChannelUpdateRequired = (claimRecord: ClaimRecord, channel: string | undefined): boolean => {
  if (channel === undefined) {
    return false
  }

  if (!claimRecord?.channel && !channel) {
    return false
  }

  return claimRecord.channel !== channel
}
